import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'volunteering-overview-tab-1-part',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-overview-tab-1.part.html',
})

export class VolunteeringOverviewTab1Part {
}
